import { render, staticRenderFns } from "./RoutingManagement.vue?vue&type=template&id=e6a3ffa8&scoped=true"
import script from "./RoutingManagement.vue?vue&type=script&lang=js"
export * from "./RoutingManagement.vue?vue&type=script&lang=js"
import style0 from "./RoutingManagement.vue?vue&type=style&index=0&id=e6a3ffa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a3ffa8",
  null
  
)

export default component.exports